// Client-side Sentry initialization.

import { useEffect } from 'react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { init, reactRouterBrowserTracingIntegration } from '@sentry/react';

// RELEASE is injected during the Webpack build, and its value is selected by
// the "/config/webpack/release.js" script, which appends @NA to its end if
// CIRCLE_TAG environment variable is not present.
// @ts-expect-error "To be revisited later"
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const release: string = RELEASE;

// ENVIRONMENT is also injected during the Webpack build,
// to have it available here before the rest of app initialization.
// @ts-expect-error "To be revisited later"
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const environment: string = ENVIRONMENT;

if (!release.endsWith('@NA')) {
  init({
    dsn: 'https://c74d5dbf057d51f51d59c6a4d2f4185c@o4509764122836992.ingest.us.sentry.io/4509770365468672',
    environment,
    integrations: [
      reactRouterBrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
        useLocation,
        useNavigationType,
      }),
    ],
    release,
  });
}
